/**
 * Fait : dit un rôle en français, pour l'afficher. `family_admin` est le nom
 *   que porte la base depuis le premier jour ; ce n'est pas un mot à montrer à
 *   quelqu'un. La traduction vit ICI, en un seul endroit, parce que la barre
 *   d'identité et l'écran du compte l'écrivent tous les deux — et que deux
 *   traductions qui divergent, c'est un rôle qui change de nom selon l'écran.
 *
 * Ne fait pas : elle ne décide d'aucun droit et ne dit pas ce qu'un rôle
 *   permet. Ce que chacun peut faire, c'est le serveur qui le tranche.
 */

import type { RoleDeCompte } from '@aymoai/shared';

/** Le rôle tel qu'on le lit à l'écran. */
export function roleEnFrancais(role: RoleDeCompte): string {
  return role === 'family_admin' ? 'parent administrateur' : 'membre';
}
